"use client";

import { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";

const LOADING_MESSAGES = [
  "Einen Moment bitte...",
  "Ich schaue mir das genauer an...",
  "Informationen werden aufbereitet...",
  "Ich suche die besten Ergebnisse...",
  "Das dauert nur einen Augenblick...",
  "Daten werden analysiert...",
  "Ich arbeite daran...",
  "Relevante Informationen werden gesammelt...",
  "Bitte haben Sie einen Moment Geduld...",
  "Fast fertig...",
];

const MESSAGE_INTERVAL = 3500;
const INITIAL_DELAY = 600;

export function TypingIndicator() {
  const [messageIndex, setMessageIndex] = useState<number | null>(null);
  const startIndex = useRef(
    Math.floor(Math.random() * LOADING_MESSAGES.length)
  );

  useEffect(() => {
    let interval: ReturnType<typeof setInterval>;
    const timer = setTimeout(() => {
      setMessageIndex(startIndex.current);
      interval = setInterval(() => {
        setMessageIndex(
          (prev) => ((prev ?? 0) + 1) % LOADING_MESSAGES.length
        );
      }, MESSAGE_INTERVAL);
    }, INITIAL_DELAY);
    return () => {
      clearTimeout(timer);
      if (interval) clearInterval(interval);
    };
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="flex items-center gap-3 justify-start"
    >
      <img
        src="/Logo_1.png"
        alt="Nightingale"
        className="h-8 w-8 shrink-0 animate-breathe"
        style={{ objectFit: "contain" }}
      />
      <div className="h-5 overflow-hidden">
        <AnimatePresence mode="wait">
          {messageIndex !== null && (
            <motion.span
              key={messageIndex}
              initial={{ opacity: 0, y: 4 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.4, ease: "easeInOut" }}
              className="text-sm text-muted-foreground block"
            >
              {LOADING_MESSAGES[messageIndex]}
            </motion.span>
          )}
        </AnimatePresence>
      </div>
    </motion.div>
  );
}
